import { gql } from "apollo-boost";


export const GET_EXCHANGRATE = gql`
query ExchangeRate($exchangeRateWhere2: ExchangeRateWhereInput) {
  exchangeRate(where: $exchangeRateWhere2) {
    kip
    baht
    usd
    id
    updatedAt
    createdAt
  }
}
`

export const GET_ALL_SUM_ORDER = gql`
query ReportAllSumOrder($where: ReportWhereInput!) {
  reportAllSumOrder(where: $where) {
    totalPrice
    productAmount
    billAmount
    sumPriceUsd
    sumPriceBaht
  }
}
`
export const GET_ALL_SUM_ORDER_V2 = gql`
  query ReportAllSumOrderV2($where: ReportWhereInput!) {
    reportAllSumOrderV2(where: $where) {
      totalPrice
      productAmount
      billAmount
      sumPriceUsd
      sumPriceBaht
      discount
    }
  }
`

export const GET_REPORT_BESTSALE = gql`
query ReportBestSeller($where: ReportWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  reportBestSeller(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    data {
      productName
      amount
      category
      brand
      unit
      totalPrice
      currency
    }
  }
}
`

export const GET_REPORT_BEST_SALE_V2 = gql`
  query ReportBestSellerV2($where: ReportWhereInput!) {
    reportBestSellerV2(where: $where) {
      data {
        productName
        amount
        category
        brand
        unit
        totalPrice
        price
        currency
        payment
      }
    }
  }
`

export const REPORT_OPTIONS = gql`
  query ReportOptions($where: ReportWhereInput!, $skip: Int, $limit: Int) {
    reportOptions(where: $where, skip: $skip, limit: $limit) {
      status
      msg
      err
      tag
      data {
        billAmount
        productAmount
        totalPrice
        sumPriceLak
        sumPriceBaht
        sumPriceUsd
        shipCost
      }
      doc {
        id
        type
        shop
        status
        stockId
        stockName
        brandId
        brandName
        categoryId
        categoryName
        shippingCost
        orderid
        options {
          name
          price
        }
        amount
        currency
      }
    }
  }
`